
import { Component, Vue } from 'vue-property-decorator';

import { namespace } from "vuex-class";
import "@/store/modules/information";
const informationState = namespace("Information");

import Form5ProcessHeader from "@/components/process/Form5/components/Form5ProcessHeader.vue";
import Form5CaseInformation from "@/components/process/Form5/components/Form5CaseInformation.vue";
import { form5StatusInfoType } from '@/types/Information/Form5';

@Component({
    components:{
        Form5ProcessHeader,
        Form5CaseInformation
    }
})
export default class StartForm5 extends Vue {

    stepsCompleted = {} as form5StatusInfoType;   

    mounted() {  
        this.stepsCompleted = {
            first: false,
            second: false,
            third: false
        }       
    }  


}
